// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "马玲",
        "week": "6,8,10,12,14,16周",
        "add": "实训楼C座308"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "马玲",
        "week": "7,9,11,15,17周",
        "add": "教学楼D座326文法"
      }
    ],
    {
      "sub": "心理健康与调适",
      "tec": "王丹",
      "week": "6-12,14-16周",
      "add": "实训E224智慧心理云会议中心"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26新核2-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "26新核1-2",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "实训楼E座503语音室"
      },
      {
        "sub": "26新核2-4",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "实训楼E座401管理"
      },
      {
        "sub": "26新核2-3",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "教学楼D座213经管"
      },
      {
        "sub": "26新核1-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "教学楼D座124新能"
      },
      {
        "sub": "26新核2-2",
        "tec": "齐越",
        "week": "6-17周",
        "add": "实训楼E座310"
      }
    ],
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[07-08节]）"
    },
    0
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "李文婉",
      "week": "6-12,15-19周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-10,14-19周",
      "add": "教学楼A座225电力"
    },
    {
      "sub": "储能科学与工程专业导论",
      "tec": "赵德鹏刘恒岐",
      "week": "6-12,14-18周",
      "add": "教学楼D座224经管"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "就业创业指导",
      "tec": "赵明明谢芳",
      "week": "14-18周",
      "add": "教学楼D座121新能"
    },
    {
      "sub": "高等数学（一）",
      "tec": "李文婉",
      "week": "6-12,15-19周",
      "add": "教学楼A座325电力"
    },
    0,
    0,
    {
      "sub": "形势与政策",
      "tec": "王姝",
      "week": "6-9周",
      "add": "教学楼C座311教务"
    }
  ],
  "4": [
    0,
    [
      {
        "sub": "大学英语（一）",
        "tec": "钟倩",
        "week": "6-17周",
        "add": "教学楼A座119信息"
      },
      {
        "sub": "26新核2-4",
        "tec": "齐越",
        "week": "6-17周",
        "add": "教学楼A座126信息"
      },
      {
        "sub": "26新核1-1",
        "tec": "宋扬",
        "week": "6-17周",
        "add": "教学楼D座120新能"
      },
      {
        "sub": "26新核1-2",
        "tec": "刘莹",
        "week": "6-17周",
        "add": "教学楼D座217经管"
      },
      {
        "sub": "26新核2-3",
        "tec": "高琳琳",
        "week": "6-17周",
        "add": "实训楼E座403语音室"
      },
      {
        "sub": "26新核2-2",
        "tec": "顾骁南",
        "week": "6-17周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26新核1-3",
        "tec": "刘岩",
        "week": "6-17周",
        "add": "教学楼D座124新能"
      }
    ],
    {
      "sub": "人工智能与计算思维",
      "tec": "马玲",
      "week": "7,9,11,15,17周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "思想道德与法治",
      "tec": "赵世龙",
      "week": "6-10,14-19周",
      "add": "教学楼A座325电力"
    },
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "李文婉",
      "week": "6-12,15-19周",
      "add": "教学楼A座426机械"
    },
    0,
    {
      "sub": "军事理论",
      "tec": "侯锦秋",
      "week": "6-12,14-15周",
      "add": "教学楼D座215经管"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
